import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Button, Space, message as antdMessage } from "antd";
import { CopyOutlined, CopyFilled } from "@ant-design/icons";
import BasePopup from "./BasePopup";
import message from "@/components/message";
import { copyTextToClipboard } from "@/utils";
import { useUserInfoStore } from "@/stores";
import "./index.scss";

interface ShareCodePopupProps {
  open: boolean;
  onClose: () => void;
  shareCode?: string;
  showButton?: boolean;
}

const ShareCodePopup: React.FC<ShareCodePopupProps> = ({
  open,
  onClose,
  showButton = true,
}) => {
  const { t } = useTranslation();
  const { Paragraph } = Typography;
  const { shareCode } = useUserInfoStore();
  const [isCopying, setIsCopying] = useState(false);

  const handleCopyShareCode = async () => {
    if (isCopying) return;

    setIsCopying(true);
    try {
      await copyTextToClipboard(shareCode);
      antdMessage.success(t("copySuccess") || "复制成功");
    } catch (err) {
      antdMessage.error(t("copyError") || "复制失败");
    } finally {
      setIsCopying(false);
    }
  };

  const content = (
    <div className='share-code-container'>
      <Paragraph
        copyable={{
          icon: [
            <CopyOutlined key='copy-icon' />,
            <CopyFilled key='copied-icon' />,
          ],
        }}
        onClick={handleCopyShareCode}>
        {shareCode}
      </Paragraph>
      {/* <Button
          type='primary'
          icon={<CopyOutlined />}
          onClick={handleCopyShareCode}
          loading={isCopying}
          size='large'>
          {isCopying ? t("copying") || "复制中..." : t("copy") || "复制分享码"}
        </Button> */}
    </div>
  );

  return (
    <BasePopup
      open={open}
      onClose={onClose}
      title={t("shareCode")}
      showButton={showButton}>
      {content}
    </BasePopup>
  );
};

export default ShareCodePopup;
